import './highlights.scss';

// @vendors
import React from 'react';

// @helpers
import { i18n } from 'core/i18n';

const highlightsData = [
    { title: 'highlights_title1', description: 'highlights_description1', type: 'acciones' },
    { title: 'highlights_title2', description: 'highlights_description2', type: 'calendario' },
    { title: 'highlights_title3', description: 'highlights_description3', type: 'predicciones' },
    { title: 'highlights_title4', description: 'highlights_description4', type: 'machine' },
];

const Highlights = () => {
    const { formatText } = i18n;

    return (
        <div className="brokerIA-highlights__container">
            {highlightsData.map(({ title, description, type }, i) => (
                <div
                    className={`brokerIA-highlights__item brokerIA-highlights__item--${type}`}
                    key={i}
                >
                    <i className={`brokerIA__icon brokerIA__icon--${type}`} />
                    <div>
                        <strong>{formatText(`brokerIA-${title}`)}</strong>
                    </div>
                    <div>{formatText(`brokerIA-${description}`)}</div>
                </div>
            ))}
        </div>
    );
};

export default Highlights;
